var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_3 = ["href"];
const _hoisted_4 = { key: 1 };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_6 = ["href"];
const _hoisted_7 = {
    key: 0,
    class: "fi fi-us"
};
const _hoisted_8 = { key: 2 };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_10 = ["href"];
const _hoisted_11 = { key: 3 };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_13 = ["href"];
import { useLocalStorage } from "@vueuse/core";
import Session from "js/Session";
import { useExtendedSupportInfo } from "src/shared/store/client/composables";
import NotificationFlash from "src/shared/v-components/ui/NotificationFlash.vue";
import { useClientProperty } from "src/shared/store/client-property/composables/useClientProperty";
import { nextTick, ref } from "vue";
const EXTOLE_SUPPORT_INFO_IS_COLLAPSED = "extole_support_info_is_collapsed";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClientSupportInfo',
    props: {
        isUserSupportUser: { type: Boolean },
        isSelfServiceUser: { type: Boolean }
    },
    emits: ["toggleInfo"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isCollapsed = useLocalStorage(EXTOLE_SUPPORT_INFO_IS_COLLAPSED, false);
        const isSuperUser = Session.getInstance().isSuperUser();
        const { extendedSupportInfo, primer: supportPrimer } = useExtendedSupportInfo();
        const { clientProperty: usOnlySupport } = useClientProperty("us_only_support");
        const clientSupportInfoWrapper = ref(null);
        const toggleInfo = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            isCollapsed.value = !isCollapsed.value;
            yield nextTick();
            const height = (_a = clientSupportInfoWrapper.value) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            emit("toggleInfo", height);
        });
        __expose({
            clientSupportInfoWrapper,
        });
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(supportPrimer).isLoading)
                    ? (_openBlock(), _createBlock(NotificationFlash, { key: 0 }))
                    : _createCommentVNode("v-if", true),
                (_unref(supportPrimer).isReady &&
                    _unref(extendedSupportInfo) &&
                    _unref(extendedSupportInfo).csm_user_email)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["client-support-info", {
                                'client-support-info--user-support-role': _ctx.isUserSupportUser || _ctx.isSelfServiceUser,
                                collapsed: _unref(isCollapsed),
                            }]),
                        ref_key: "clientSupportInfoWrapper",
                        ref: clientSupportInfoWrapper
                    }, [
                        _createElementVNode("button", {
                            onClick: toggleInfo,
                            class: "button button--medium button--tertiary button--circle button__toggle button__toggle--info"
                        }, [
                            _createElementVNode("i", {
                                class: _normalizeClass(["far", {
                                        'fa-angle-up': _unref(isCollapsed),
                                        'fa-angle-down': !_unref(isCollapsed),
                                    }])
                            }, null, 2 /* CLASS */)
                        ]),
                        (_unref(extendedSupportInfo).csm_user_email)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_1, [
                                _createTextVNode("CSM: "),
                                _hoisted_2,
                                _createElementVNode("a", {
                                    href: `mailto:${_unref(extendedSupportInfo).csm_user_email}`
                                }, _toDisplayString(_unref(extendedSupportInfo).csm_user_name), 9 /* TEXT, PROPS */, _hoisted_3)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (_unref(extendedSupportInfo).support_user_email)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
                                _createTextVNode("Support Engineer: "),
                                _hoisted_5,
                                _createElementVNode("a", {
                                    href: `mailto:${_unref(extendedSupportInfo).support_user_email}`
                                }, [
                                    _createTextVNode(_toDisplayString(_unref(extendedSupportInfo).support_user_name) + " ", 1 /* TEXT */),
                                    (((_a = _unref(usOnlySupport)) === null || _a === void 0 ? void 0 : _a.value) === 'true')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                                        : _createCommentVNode("v-if", true)
                                ], 8 /* PROPS */, _hoisted_6)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (_unref(isSuperUser) && _unref(extendedSupportInfo).slack_channel_name)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_8, [
                                _createTextVNode("Slack Channel:"),
                                _hoisted_9,
                                _createElementVNode("a", {
                                    href: `https://extole.slack.com/app_redirect?channel=${_unref(extendedSupportInfo).slack_channel_name.substring(1)}`,
                                    target: "_blank"
                                }, _toDisplayString(_unref(extendedSupportInfo).slack_channel_name), 9 /* TEXT, PROPS */, _hoisted_10)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (_unref(extendedSupportInfo).external_slack_channel_name)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_11, [
                                _createTextVNode("External Slack Channel:"),
                                _hoisted_12,
                                _createElementVNode("a", {
                                    href: `https://extole.slack.com/app_redirect?channel=${_unref(extendedSupportInfo).external_slack_channel_name.substring(1)}`,
                                    target: "_blank"
                                }, _toDisplayString(_unref(extendedSupportInfo).external_slack_channel_name), 9 /* TEXT, PROPS */, _hoisted_13)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
